import { createApp } from 'vue';
import App from './app.vue';
import { initSetups } from './setups.js';
import { ready } from './calc.js';

// calc.js's numeric core is backed by wasm — wait for it to finish
// instantiating before anything in the app can call into it. An async IIFE
// rather than top-level await: Parcel's optimizer (@parcel/optimizer-swc)
// rejects top-level await outright.
(async () => {
  await ready;

  initSetups();
  createApp(App).mount('#app');
})();

